export default __webpack_public_path__ + "static/media/add_accomodation_service.148caa45.png";